<div class="card-base">
    <div class="card-content-study-report-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{ filt.toolTip }}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>
        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-study-report-control-filter #filters></app-study-report-control-filter>
                </div>
                <div class="pull-right div-header-right">
                    <!-- Botón visibilidad de columnas -->
                    <button class="card-inline margin-top-medium" [matMenuTriggerFor]="columnsMenu" type="button" mat-mini-fab matTooltip="Columnas visibles">
            <mat-icon>view_column</mat-icon>
          </button>
                    <mat-menu #columnsMenu="matMenu" class="columns-menu">
                        <button mat-menu-item (click)="showAllColumns(); $event.stopPropagation()">
              <mat-icon>visibility</mat-icon><span>Mostrar todas</span>
            </button>
                        <mat-divider></mat-divider>
                        <button *ngFor="let col of availableColumns" class="columns-menu-item" mat-menu-item (click)="setColumnVisibility(col.field, !col.visible); $event.stopPropagation()">
              <mat-checkbox [checked]="col.visible" (click)="$event.stopPropagation()"
                (change)="setColumnVisibility(col.field, $event.checked)">{{ col.title }}</mat-checkbox>
            </button>
                    </mat-menu>

                    <mat-spinner *ngIf="loadingMasiveAction" diameter="50"> </mat-spinner>
                    <button *ngIf="!loadingMasiveAction" class="card-inline margin-top-medium" [matMenuTriggerFor]="menuItem" type="button" mat-mini-fab>
            <mat-icon>more_vert</mat-icon>
          </button>

                    <mat-spinner [diameter]="50" *ngIf="loadingAction"></mat-spinner>
                    <mat-menu #menuItem="matMenu">
                        <button (click)="massivePrintDos()" mat-menu-item>
              <span> <b>Impresión masiva</b></span>
            </button>
                        <button (click)="sendMassiveMails()" mat-menu-item>
              <span> <b>Enviar por mail</b></span>
            </button>
                        <button (click)="publishWeb()" mat-menu-item>
              <span> <b>Publica web</b></span>
            </button>
                        <button (click)="noPublishWeb()" mat-menu-item>
              <span> <b>No publica web</b></span>
            </button>
                        <button (click)="reportPhysicianReplacement()" mat-menu-item>
              <span> <b>Asignar informante</b></span>
            </button>
                        <button (click)="reportPhysicianClear()" mat-menu-item>
              <span> <b>Blanquear informante</b></span>
            </button>
                        <button (click)="printOrders()" mat-menu-item>
              <span> <b>Imprimir ordenes de retiro</b></span>
            </button>

                        <button (click)="sendDeliverySector()" mat-menu-item>
              <span> <b>Enviar a sector de entrega</b></span>
            </button>

                        <button (click)="studyReportsUnlock()" mat-menu-item>
              <span> <b>Desbloquear informes</b></span>
            </button>
                    </mat-menu>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="card-content margin-botton-medium">
                <div class="grid-scroll-container">
                    <p-table class="search-table" [value]="dataSource" [tableStyle]="{ width: '100%' }">
                        <ng-template pTemplate="header">
                            <tr class="search-table-header">
                                <!-- Checkbox selección masiva -->
                                <th class="checkbox-column">
                                    <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
                                </th>
                                <!-- Columna alerta de color (fija, no configurable) -->
                                <th style="width: 18px;"></th>
                                <!-- Columnas configurables -->
                                <th class="resizable-header" *ngFor="let col of orderedColumnsDefinition" [style.width.px]="col.width" (dragover)="onHeaderDragOver($event)" (drop)="onHeaderDrop($event, col.field)">
                                    <div class="header-top-row">
                                        <span class="header-drag-content">
                      <span class="column-title" (click)="sortByColumn(col.field)">
                        {{ col.title }}
                        <mat-icon class="sort-icon">{{ getSortIcon(col.field) }}</mat-icon>
                      </span>
                                        <mat-icon class="header-drag-handle" draggable="true" (dragstart)="onHeaderDragStart($event, col.field)" (dragend)="onHeaderDragEnd()" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
                                        </span>
                                        <span class="column-resize-handle" (mousedown)="startResize($event, col.field)"></span>
                                    </div>
                                    <input class="column-filter-input" [value]="columnFilters[col.field] || ''" (click)="$event.stopPropagation()" (input)="onColumnFilterInput(col.field, $event.target.value)" placeholder="Filtrar" />
                                </th>
                                <th class="actions-column"></th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-element>
                            <tr class="search-table-cell">
                                <!-- Checkbox por fila -->
                                <td class="checkbox-column">
                                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)"></mat-checkbox>
                                </td>
                                <!-- Alerta de color -->
                                <td style="width: 18px; padding: 4px;">
                                    <div [ngClass]="{ green: element.GreenAlert, red: element.RedAlert, yellow: element.YellowAlert }"></div>
                                </td>
                                <!-- Celdas configurables -->
                                <td *ngFor="let col of orderedColumnsDefinition">
                                    <ng-container [ngSwitch]="col.field">
                                        <span *ngSwitchCase="'reservationHour'">{{ element.DateTime | date:'dd/MM/yyyy HH:mm' }}</span>
                                        <span *ngSwitchCase="'deliveryHour'">{{ element.DeliveryDate | date:'dd/MM/yyyy HH:mm' }}</span>
                                        <span *ngSwitchCase="'protocol'">{{ element.Protocol }}</span>
                                        <span *ngSwitchCase="'patientFullName'">{{ element.PatientFullName }}</span>
                                        <span *ngSwitchCase="'practiceName'">{{ element.PracticeName }}</span>
                                        <span *ngSwitchCase="'serviceName'">{{ element.ServiceName }}</span>
                                        <span *ngSwitchCase="'entityName'">{{ element.EntityName }}</span>
                                        <span *ngSwitchCase="'state'">{{ element.State }}</span>
                                        <span *ngSwitchCase="'studyReportRegion'">{{ element.StudyReportRegion }}</span>
                                        <span *ngSwitchCase="'cantidad'">{{ element.NumberOfPractices }}</span>
                                        <span *ngSwitchCase="'adminControled'">{{ element.AdminControled }}</span>
                                        <span *ngSwitchCase="'studyReportPhysician'">{{ element.StudyReportPhysician }}</span>
                                        <span *ngSwitchCase="'statusPhotographyName'">{{ element.StatusPhotographyName }}</span>
                                        <span *ngSwitchCase="'published'">{{ element.PublishedYesNo }}</span>
                                        <span *ngSwitchCase="'lastLogisticscommentary'">{{ element.LastLogisticscommentary }}</span>
                                        <span *ngSwitchCase="'visualizationCode'">
                      <mat-icon matTooltip="Copiar link del informe" (click)="copyLink(element.VisualizationCode)">content_copy</mat-icon>
                    </span>
                                    </ng-container>
                                </td>
                                <!-- Acciones por fila -->
                                <td class="actions-column">
                                    <mat-spinner *ngIf="element.Loading" [diameter]="15"></mat-spinner>
                                    <button mat-icon-button *ngIf="!element.Loading" [matMenuTriggerFor]="rowMenu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                                    <mat-menu #rowMenu="matMenu">
                                        <button *ngIf="canPublishForced && !element.PublishWebForced" (click)="publishWebForced(element)" mat-menu-item>
                      <span>Publica web con faltantes</span>
                    </button>
                                        <button *ngIf="canPublishForced && element.PublishWebForced" (click)="noPublishWebForced(element)" mat-menu-item>
                      <span>No publica web con faltantes</span>
                    </button>
                                        <button (click)="viewMergedStudyReport(element)" mat-menu-item><span>Ver</span></button>
                                        <button (click)="openAdmisionLogViewDialog(element)" mat-menu-item><span>Actividades</span></button>
                                        <button (click)="openLogisticsCommnetEdit(element)" mat-menu-item><span>Comentarios Servicio/Logística</span></button>
                                        <button (click)="openStatusPhotographyEdit(element)" mat-menu-item><span>Estado fotografiado</span></button>
                                        <button mat-menu-item (click)="goMedicalOrderScann(element)"><span>Ver escaneos</span></button>
                                        <button mat-menu-item (click)="studyReportUnlock(element)"><span>Desbloquear informe</span></button>
                                    </mat-menu>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <pager [selectedAmount]="selectedAmount" (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>
